// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1CeUo","alert":"SettungsInbox_alert__3Ckgr"};